import React from "react";
import "./Footer.css";

const Footer: React.FC = () => {
  return <footer className="app-footer">Copyright © 2025 Insecta</footer>;
};

export default Footer;
